/**
 * Expand mapping corners with row_dict → absolute pan/tilt per seat.
 * Seat math MUST use acsSeatMath (ACS clone — DO NOT CHANGE).
 */
import {
  calculatePanTilt,
  isRowInRegion,
  setRowDict,
} from './acsSeatMath';

const corner = (region, pos, i) => (
  (region || []).find((c) => c?.position === pos) || region?.[i] || null
);

/** Expand corners with row_dict, then pan/tilt via Mapping calculatePanTilt. */
export const seatsFromMap = (camMap, rowDict) => {
  if (!camMap?.sections?.length || !rowDict) return [];

  // calculatePanTilt / isRowInRegion read the module singleton.
  setRowDict(rowDict);

  const rows = Object.keys(rowDict).sort((a, b) => rowDict[a] - rowDict[b]);
  const refPan = Number(camMap.ref_point?.pan) || 0;
  const refTilt = Number(camMap.ref_point?.tilt) || 0;
  const out = [];

  camMap.sections.forEach((section) => {
    const name = String(section?.name || '').trim() || '?';
    (section.regions || []).forEach((raw, ri) => {
      if (!Array.isArray(raw) || raw.length < 4) return;
      // Mapping order: [0] TL, [1] TR, [2] BL, [3] BR
      const region = [
        corner(raw, 'top_left', 0),
        corner(raw, 'top_right', 1),
        corner(raw, 'bottom_left', 2),
        corner(raw, 'bottom_right', 3),
      ];
      if (region.some((c) => c?.pan == null || c?.tilt == null)) return;

      const sMin = Math.min(Number(region[0].seat), Number(region[1].seat));
      const sMax = Math.max(Number(region[0].seat), Number(region[1].seat));
      if (![sMin, sMax].every(Number.isFinite)) return;
      const regionKey = `${name}#${ri}`;

      rows.forEach((row) => {
        if (!isRowInRegion(row, region)) return;
        for (let seat = sMin; seat <= sMax; seat += 1) {
          const { pan, tilt } = calculatePanTilt(row, seat, region);
          if (Number.isFinite(pan) && Number.isFinite(tilt)) {
            out.push({
              section: name,
              regionKey,
              row: String(row),
              seat,
              pan: pan + refPan,
              tilt: tilt + refTilt,
            });
          }
        }
      });
    });
  });
  return out;
};

export default seatsFromMap;
